import { usePrevPageRouter } from '@graphcommerce/framer-next-pages'
import { ProductPageBreadcrumbFragment, productPageCategory } from '@graphcommerce/magento-product'
import { iconChevronLeft, IconSvg } from '@graphcommerce/next-ui'
import { Box, Breadcrumbs, BreadcrumbsProps, Link, Typography } from '@mui/material'

type ProductPageBreadcrumbsProps = ProductPageBreadcrumbFragment & BreadcrumbsProps

export function ProductPageMobileBreadcrumb(props: ProductPageBreadcrumbsProps) {
  const { categories } = props
  const prev = usePrevPageRouter()

  const category =
    categories?.find((c) => `/${c?.url_path}` === prev?.asPath) ?? productPageCategory(props)

  return (
    <Breadcrumbs>
      {category && (
        <Link href={`/${category?.url_path}`} underline='hover' color='text.primary'>
          <Box sx={{ display: 'flex', alignContent: 'center' }}>
            <IconSvg src={iconChevronLeft} size='medium' />
            <Typography variant='caption' sx={{ marginTop: '1px' }}>
              {category.name}
            </Typography>
          </Box>
        </Link>
      )}
    </Breadcrumbs>
  )
}
